import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

import { LEGAL_ROUTES } from '../../data/legalContent';
import {
  EmailCaptureCard,
  EmailRow,
  EmailInput,
  EmailButton,
  EmailConsentLabel,
  HelperText,
  SectionTitle,
} from '../../pages/results/resultsStyles';

export const validateEmail = (value) => {
  const trimmed = (value || '').trim();
  if (!trimmed) return 'Email is required';
  if (!trimmed.includes('@') || trimmed.startsWith('@') || trimmed.endsWith('@')) return 'Enter a valid email';
  if (trimmed.length > 254) return 'Email is too long';
  return '';
};

const ResultsEmailSection = ({
  email,
  setEmail,
  emailConsent,
  setEmailConsent,
  emailError,
  setEmailError,
  emailSaved,
  setEmailSaved,
  isEmailSending,
  emailDeliveryMode,
  hasAnyEmailCapture,
  onSubmit,
  variants,
}) => (
  <EmailCaptureCard
    as={motion.section}
    variants={variants}
    aria-labelledby="email-capture-heading"
    id="email-capture-heading"
  >
    <SectionTitle id="email-capture-heading" as="h2">
      Get your report by email
    </SectionTitle>
    <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
      Send your full founder report to your inbox. Share with a co-founder or revisit anytime.
    </p>
    <EmailRow>
      <EmailInput
        type="email"
        value={email}
        placeholder="you@company.com"
        onChange={(e) => {
          setEmail(e.target.value);
          setEmailError('');
          setEmailSaved(false);
        }}
        aria-label="Email address"
        aria-describedby={emailError ? 'email-error' : undefined}
        aria-invalid={Boolean(emailError)}
        autoComplete="email"
      />
      <EmailButton
        type="button"
        onClick={onSubmit}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        disabled={!email.trim() || isEmailSending}
        aria-busy={isEmailSending}
      >
        {isEmailSending ? 'Sending…' : 'Send my report'}
      </EmailButton>
    </EmailRow>
    <EmailConsentLabel>
      <input
        type="checkbox"
        checked={emailConsent}
        onChange={(e) => {
          setEmailConsent(e.target.checked);
          setEmailError('');
        }}
      />
      <span>
        I agree to the <Link to={LEGAL_ROUTES.privacy}>Privacy Policy</Link> and want my report emailed to this address.
      </span>
    </EmailConsentLabel>
    {emailError && (
      <HelperText id="email-error" role="alert" style={{ color: '#f87171' }}>
        {emailError}
      </HelperText>
    )}
    {emailSaved && emailDeliveryMode === 'sent' && (
      <HelperText role="status" style={{ color: 'var(--type-accent, var(--primary-color))' }}>
        Check your inbox. Your report is on the way.
      </HelperText>
    )}
    {emailSaved && emailDeliveryMode === 'local' && (
      <HelperText role="status" style={{ color: 'var(--type-accent, var(--primary-color))' }}>
        Saved locally. Email delivery activates once Resend is configured on Vercel.
      </HelperText>
    )}
    {!emailSaved && !emailError && hasAnyEmailCapture && (
      <HelperText>Your email is saved on this device.</HelperText>
    )}
  </EmailCaptureCard>
);

export default ResultsEmailSection;
